import React from "react";
import {Route, Routes} from "react-router-dom";
import ManagerList from "../container/manager/ManagerList";
import CreateManager from "../container/manager/CreateManager";
import UpdateManager from "../container/manager/UpdateManager";

const Manager = () => {
  return (
    <Routes>
      <Route path="/*" element={<ManagerList />} />
      <Route path="Create" element={<CreateManager />} />
      <Route path="Edit/:id" element={<UpdateManager />} />
    </Routes>
  );
};

export default Manager;
